import { Box } from '@mantine/core';
import { IconCalendarEvent, IconCash, IconCircles, IconFiles, IconInbox, IconShare } from '@tabler/icons';
import { FC, useContext } from 'react';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import NavigationLink from '../../Atoms/Navigation/NavigationLink';
import EventHeadActions from '../../Molecules/Event/EventHeadActions';
import { useNavigationItem } from '../../Organismns/Navigation/NavigationItemHook';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import { WindowContext } from '../../Service/Context/WindowContext';
import { TestS } from '../../TestS';
import { LicenceS } from '../../Service/LicenceS';
import EmailBoxCounter from '../Emails/EmailBoxCounter';
import { EventParticipationsContext } from '../../Service/Context/EventParticipationContextV2';
import { PostboxCountersContext } from '../../Service/Context/PostboxCountersContext';
import EventBreadCrumbs from './EventBreadCrumbs';
import { useBookitupScope } from '../../Service/Context/BookitupSubscriptionContext';

const EventFormNavbar: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const { id: eventId } = useParams();
  const navigate: NavigateFunction = useNavigate();
  const resouceItemActive = useNavigationItem(`/events/${eventId}/resources`);
  const { profile } = useContext<any>(ProfileContext);
  const { isScopeSelected: hasResourceScope } = useBookitupScope('RESOURCE');
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');
  const { isScopeSelected: hasContractsScope } = useBookitupScope('CONTRACTS');
  const { isScopeSelected: hasQuestionnairesScope } = useBookitupScope('QUESTIONNAIRES');
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');
  const hasAnyDocumentScope = hasDocumentsScope || hasContractsScope || hasQuestionnairesScope;
  const { sm } = useContext(WindowContext);
  const financeSectionActive = useNavigationItem(`/events/${eventId}/finance`);
  const sharesSectionActive = useNavigationItem(`/events/${eventId}/shares`);
  const documentsItemActive = useNavigationItem(`/events/${eventId}/documents`);
  const inboxItemActive = useNavigationItem(`/events/${eventId}/emails/inbox`);
  const draftsItemActive = useNavigationItem(`/events/${eventId}/emails/drafts`);
  const scheduledItemActive = useNavigationItem(`/events/${eventId}/emails/scheduled`);
  const failedItemActive = useNavigationItem(`/events/${eventId}/emails/failed`);
  const outboundItemActive = useNavigationItem(`/events/${eventId}/emails/outbound`);
  const trashItemActive = useNavigationItem(`/events/${eventId}/emails/trash`);
  const { id: profileId } = profile;

  const { unreadMessagesProps } = useContext(EventParticipationsContext);
  const { unreadCount } = unreadMessagesProps;
  const { failedCount, scheduledCount } = useContext(PostboxCountersContext);

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = (path: string) => {
    navigate(path);
    closeNavBar();
  };

  return (
    <>
      {!sm && (
        <Box p="md">
          <EventBreadCrumbs />
        </Box>
      )}
      <NavigationLink
        variant="filled"
        label="Details"
        onClick={() => _onClick(`/events/${eventId}/details`)}
        active={useNavigationItem(`/events/${eventId}/details`)}
        icon={sm && <IconCalendarEvent size={16} />}
      />

      {profile && hasResourceScope && LicenceS.hasAccessToResourceModule(profile.id) && (
        <NavigationLink
          variant="filled"
          label="Ressourcen"
          onClick={() => _onClick(`/events/${eventId}/resources`)}
          active={resouceItemActive}
          icon={sm && <IconCircles size={16} />}
        />
      )}

      {hasAnyDocumentScope && (
        <NavigationLink
          variant="filled"
          label="Dateien"
          onClick={() => _onClick(`/events/${eventId}/documents`)}
          active={documentsItemActive}
          icon={sm && <IconFiles size={16} />}
          testId={TestS.Events.Navigate.TO_DOCUMENTS}
        />
      )}
      {hasEmailScope && (
        <NavigationLink defaultOpened label="E-Mails" icon={sm && <IconInbox size={16} />} childrenOffset={28}>
          <NavigationLink
            label="Posteingang"
            active={inboxItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/inbox`)}
            variant="filled"
            rightSection={<EmailBoxCounter count={unreadCount} />}
          />
          <NavigationLink
            label="Entwürfe"
            active={draftsItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/drafts`)}
            variant="filled"

          />
          <NavigationLink
            label="Geplant"
            active={scheduledItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/scheduled`)}
            variant="filled"
            rightSection={<EmailBoxCounter count={scheduledCount} />}
          />
          <NavigationLink
            label="Fehlgeschlagen"
            active={failedItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/failed`)}
            variant="filled"
            rightSection={<EmailBoxCounter count={failedCount} />}
          />
          <NavigationLink
            label="Gesendet"
            active={outboundItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/outbound`)}
            variant="filled"
          />
          <NavigationLink
            label="Papierkorb"
            active={trashItemActive}
            onClick={() => _onClick(`/events/${eventId}/emails/trash`)}
            variant="filled"

          />
        </NavigationLink>
      )}
      {hasDocumentsScope && (
        <NavigationLink
          label="Freigaben"
          icon={sm && <IconShare size={16} />}
          active={sharesSectionActive}
          onClick={() => _onClick(`/events/${eventId}/shares`)}
          variant="filled"
        />
      )}
      {hasDocumentsScope && profileId && profileId < 57509 && (
        <NavigationLink
          label="Verdienst"
          icon={sm && <IconCash size={16} />}
          active={financeSectionActive}
          onClick={() => _onClick(`/events/${eventId}/finance`)}
          variant="filled"
        />
      )}

      <Box sx={{ position: 'absolute', bottom: 20 }}>
        <EventHeadActions closeNavBar={closeNavBar} />
      </Box>
    </>
  );
};

export default EventFormNavbar;
